export const vs2jen2LimitedReleaseDetailConstants = {
  VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
    "VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING",
  VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
    "VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS",
  VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
    "VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const createVs2jen2LimitedReleaseDetailConstants = {
  CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
    "CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING",
  CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
    "CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS",
  CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
    "CREATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const editVs2jen2LimitedReleaseDetailConstants = {
  EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
    "EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING",
  EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
    "EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS",
  EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
    "EDIT_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deleteVs2jen2LimitedReleaseDetailConstants = {
  DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
    "DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING",
  DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS",
  DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
    "DELETE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const activateVs2jen2LimitedReleaseDetailConstants = {
  ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
    "ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING",
  ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
    "ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS",
  ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
    "ACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE",
};

export const deactivateVs2jen2LimitedReleaseDetailConstants = {
  DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING:
    "DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_LOADING",
  DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS:
    "DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_SUCCESS",
  DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE:
    "DEACTIVATE_VS2JEN2_LIMITED_RELEASE_DETAIL_FAILURE",
};
